import React from 'react';
import { ListItem } from '@mui/material';

import { makeStyles } from '~/UIKit/Style';
import { Avatar, Typography } from '~/UIKit';
import { BORDER_COLOR, PRIMARY_BLUE, LIGHT_BLUE } from '~/Constants/Colors.constants';

const useStyles = makeStyles({
  ListItem: {
    borderBottom: `1px solid ${BORDER_COLOR}`,
    height: 60,
    '& .MuiTouchRipple-child': {
      backgroundColor: PRIMARY_BLUE,
    },
  },
  name: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  imageContainer: {
    display: 'flex',
    marginRight: 15,
    '& .MuiSvgIcon-root': {
      backgroundColor: LIGHT_BLUE,
      width: 30,
      height: 30,
      borderRadius: 15,
    },
  },
  Checkbox: {
    marginLeft: 'auto',
  },
});

export interface IModalSelectPopoverItem {
  name: string;
  icon?: React.ReactNode;
  testId?: string;
  onClick: () => void;
  imageUrl?: string;
  children: React.ReactNode;
}

export const ModalSelectPopoverItem = ({
  name,
  icon,
  testId,
  onClick,
  imageUrl,
  children,
}: IModalSelectPopoverItem) => {
  const { classes } = useStyles();
  return (
    <ListItem button className={classes.ListItem} data-testid={testId} onClick={onClick}>
      <div className={classes.imageContainer}>
        {icon ?? <Avatar imageUrl={imageUrl} name={name} />}
      </div>
      <Typography className={classes.name} variant="h6">
        {name}
      </Typography>
      {children}
    </ListItem>
  );
};
